module.exports = __webpack_public_path__ + "static/blog15-0c8713b3e9210777ed988b7773f6b15b.png";